import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

console.log("[SUPABASE] URL configurada:", supabaseUrl ? "OK" : "FALTANDO");
console.log("[SUPABASE] KEY configurada:", supabaseKey ? "OK" : "FALTANDO");

if (!supabaseUrl || !supabaseKey) {
  console.error("[SUPABASE] ERRO CRÍTICO: VITE_PUBLIC_SUPABASE_URL ou VITE_PUBLIC_SUPABASE_ANON_KEY não estão configuradas!");
}

export const supabase = createClient(supabaseUrl || '', supabaseKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export function useSupabase() {
  return supabase;
}